import { render } from "./CompanyEditor.vue?vue&type=template&id=c199ae1e&scoped=true&ts=true"
import script from "./CompanyEditor.vue?vue&type=script&lang=ts"
export * from "./CompanyEditor.vue?vue&type=script&lang=ts"

import "./CompanyEditor.vue?vue&type=style&index=0&id=c199ae1e&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c199ae1e"]])

export default __exports__